/**
 * useCreatePaymentIntent
 *
 * Creates a Stripe PaymentIntent on the server and returns
 * the client_secret needed to mount Stripe Elements.
 */
import { useMutation } from '@tanstack/react-query';
import apiClient from '@/lib/axios';

export function useCreatePaymentIntent() {
  return useMutation({
    mutationFn: async ({ amountCents, currency = 'usd', recurring = false, catalystId = null }) => {
      const { data } = await apiClient.post('/api/payments/intent', {
        amount: amountCents,
        currency,
        recurring,
        metadata: { catalystId },
      });
      return data; // { client_secret, payment_intent_id }
    },
  });
}
